function initReveal() {
  const items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach((el) => el.classList.add('mt-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.mtDelay || 0;
          setTimeout(() => entry.target.classList.add('mt-visible'), delay);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  items.forEach((el) => observer.observe(el));
}

function initBuyNow() {
  const botones = document.querySelectorAll('[data-mt-buy-now]');
  if (!botones.length) return;

  botones.forEach((boton) => {
    boton.addEventListener('click', async () => {
      if (boton.disabled) return;

      const formId = boton.dataset.mtBuyNowForm;
      const form = formId ? document.getElementById(formId) : null;
      const variantInput = form ? form.querySelector('.product-variant-id') : null;
      const variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;

      const textoOriginal = boton.innerHTML;
      boton.disabled = true;
      boton.innerHTML = '<span>Adding…</span>';

      try {
        const respuesta = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });

        if (!respuesta.ok) throw new Error('No se pudo agregar al carrito');

        window.location.href = '/checkout';
      } catch (error) {
        boton.disabled = false;
        boton.innerHTML = textoOriginal;
      }
    });
  });
}

function initResenasCarrusel() {
  const carruseles = document.querySelectorAll('[data-mt-carousel]');
  if (!carruseles.length) return;

  carruseles.forEach((carrusel) => {
    const track = carrusel.querySelector('[data-mt-carousel-track]');
    const dots = Array.from(carrusel.querySelectorAll('[data-mt-carousel-dot]'));
    const slides = track ? Array.from(track.children) : [];
    if (!track || slides.length <= 1) return;

    let index = 0;
    let timer = null;
    const segundos = parseFloat(carrusel.dataset.mtAutoplay || '0');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function irA(nuevoIndex) {
      index = (nuevoIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot, i) => dot.classList.toggle('mt-resenas__dot--activo', i === index));
    }

    function siguiente() {
      irA(index + 1);
    }

    function detenerAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function iniciarAutoplay() {
      if (reducedMotion || !segundos) return;
      detenerAutoplay();
      timer = setInterval(siguiente, segundos * 1000);
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        irA(i);
        iniciarAutoplay();
      });
    });

    carrusel.addEventListener('mouseenter', detenerAutoplay);
    carrusel.addEventListener('mouseleave', iniciarAutoplay);
    carrusel.addEventListener('focusin', detenerAutoplay);
    carrusel.addEventListener('focusout', iniciarAutoplay);

    irA(0);
    iniciarAutoplay();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initBuyNow();
  initResenasCarrusel();
});
